module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-Hant":{"id":"學校 ID","password":"密碼","forStaff":"提供社團幹部登入管理","pleaseReconfirmIdOrPassword":"認證失敗，請重新確認 ID 或密碼","connectionIssue":"連線發生問題，請重新再試: "},"en":{"id":"School ID","password":"Password","forStaff":"A management system for staff","pleaseReconfirmIdOrPassword":"Wrong ID or password. Please try again.","connectionIssue":"Network connection error. Please try again: "}}')
  delete Component.options._Ctor
}
